import React from 'react';
import { render } from 'react-dom';

import { getErrorMessageKey } from '../../util/errorCodes';
import facebookPixelTracking from '../../util/facebookPixelTracking';
import googleEcommerceTracking from '../../util/googleEcommerceTracking';
import jsonGet from '../../util/jsonGet';

import BookingAcknowledgement from '../react/BookingAcknowledgement';
import ErrorMessage from '../react/Core/ErrorMessage';
import Loading from '../react/Core/Loading';
import ProgressBar from '../react/ProgressBar';
import { STORAGE_KEYS, hasLocalStorageKeyAndValue, setLocalStorage } from '../../util/storage';

export default class BookingAcknowledgementRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model, currentProgressBarStep, loadApi, title, pageContent, ctaButton } =
      this.context.dataset;
    if (!model || !currentProgressBarStep || !loadApi) throw Error('Missing a required dataset');

    let labels;
    try {
      labels = JSON.parse(model);
    } catch (e) {
      labels = undefined;
      console.error('Error parsing labels json: ', model);
    }

    let content;
    try {
      content = JSON.parse(pageContent);
    } catch (e) {
      content = undefined;
      console.error('Error parsing page contents: ', pageContent);
    }

    let button;
    try {
      button = JSON.parse(ctaButton);
    } catch (e) {
      button = undefined;
      console.error('Error parsing cta button: ', ctaButton);
    }

    jsonGet(loadApi, null, (response) => {
      if (response.errorCode) {
        const errorMessageKey = getErrorMessageKey(response.errorCode);
        return render(
          <ErrorMessage text={labels[errorMessageKey] || response.message} />,
          this.context
        );
      }

      return render(
        BookingAcknowledgementRender.renderMain(
          response,
          labels,
          content,
          button,
          title,
          currentProgressBarStep
        ),
        this.context
      );
    });

    return render(
      BookingAcknowledgementRender.renderMain(
        undefined,
        labels,
        content,
        button,
        title,
        currentProgressBarStep
      ),
      this.context
    );
  }

  static renderMain(acknowledgementLoadData, labels, content, button, title, selectedStep) {
    const data = acknowledgementLoadData;

    if (
      data &&
      !hasLocalStorageKeyAndValue(STORAGE_KEYS.transactionReference, data?.transactionReference)
    ) {
      googleEcommerceTracking(data);
      facebookPixelTracking(data);
      // stop duplicate purchase events on same transaction
      setLocalStorage(STORAGE_KEYS.transactionReference, data.transactionReference);
    }

    return (
      <>
        <ProgressBar steps={data?.progressBarSteps} selectedStep={selectedStep} />
        <div className="PageTitle">
          <h1 className="PageTitle_title">{title}</h1>
        </div>
        {data ? (
          <BookingAcknowledgement data={data} labels={labels} content={content} button={button} />
        ) : (
          <Loading />
        )}
      </>
    );
  }
}
